import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api-client";
import type { InterpretationResponse, InterpretationListItem } from "@/types/interpretation.types";

// Hooks da interpretação (canal de tela, GESTOR). Criar é síncrono: o backend
// computa os fatos na hora e devolve o artefato. Invalida o histórico da rodada.

export const interpretationKeys = {
  forSimulation: (simulationId: string) => ["interpretations", simulationId] as const,
  detail: (id: string) => ["interpretation", id] as const,
};

/** Histórico de interpretações de uma rodada (lista resumida). */
export function useInterpretations(simulationId: string, enabled = true) {
  return useQuery({
    queryKey: interpretationKeys.forSimulation(simulationId),
    queryFn: () =>
      api.get<InterpretationListItem[]>(`/api/v1/simulations/${simulationId}/interpretations`),
    enabled: enabled && simulationId.length > 0,
  });
}

/** Detalhe de uma interpretação (fatos + narrativa). */
export function useInterpretation(id: string | undefined) {
  return useQuery({
    queryKey: interpretationKeys.detail(id ?? ""),
    queryFn: () => api.get<InterpretationResponse>(`/api/v1/interpretations/${id}`),
    enabled: !!id,
  });
}

/** Interpreta uma rodada (RUN) — só fatos (sem narrativa; canal de tela). */
export function useCreateRunInterpretation(simulationId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () =>
      api.post<InterpretationResponse>(`/api/v1/simulations/${simulationId}/interpretations`, {}),
    onSuccess: (res) => {
      void qc.invalidateQueries({ queryKey: interpretationKeys.forSimulation(simulationId) });
      qc.setQueryData(interpretationKeys.detail(res.id), res);
    },
  });
}
